const DETERMINATION_STATUS = {
  NUEVO: 1,
  APROBADO: 2,
  OBJETADO: 3,
  CANCELADO: 4,
};

export default DETERMINATION_STATUS;
